import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { BrowserAuthError } from "@azure/msal-browser";
import { useState, useEffect } from "react";
import { msalInstance, msalInitializedPromise } from "./configs/msal-instance";

import App from "./App";
import { Login } from "./screens/login";

function AppShell() {
  const [isMsalInitialized, setIsMsalInitialized] = useState(false);

  const pathname = window.location.pathname;
  const isPublicRoute =
    pathname === "/licenses" || pathname.startsWith("/details");

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInitializedPromise;
        await msalInstance.handleRedirectPromise();
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
        setIsMsalInitialized(true);
      } catch (error) {
        if (error instanceof BrowserAuthError && error.errorCode === "no_token_request_cache_error") {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
          }
          setIsMsalInitialized(true);
        } else {
          console.error("Failed to initialize MSAL:", error);
        }
      }
    };
    initializeMsal();
  }, []);

  if (!isMsalInitialized) {
    return <div>Loading...</div>;
  }

  if (isPublicRoute) {
    return (
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <App />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}

export default AppShell;
